// BASE
exports.white = '#FFF';
exports.black = '#000';
exports.gray = '#8F8F8F';
exports.silver = '#BEBEBE';
exports.gallery = '#EDEDED';
exports.mineShaft = '#3E3E3E';
exports.magicMint = '#B5F4CF';
exports.darkBlue = '#023B4D';
exports.orange = '#FB552E';
exports.mountainMeadow = '#009E27';
exports.mountainMeadowTwo = '#28DE73';

exports.transparent = 'transparent';
